import * as React from 'react';
import { isEmpty } from 'lodash';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import DiscoveryFiltersTitle from 'modules/discovery/components/filters/title/DiscoveryFiltersTitle';
import CheckboxSelector from 'modules/discovery/components/checkbox-selector/CheckboxSelector';
import DiscoveryCreatorsFiltersShare from '../share/DiscoveryCreatorsFiltersShare';

import { __t, applyTranslations } from 'utils/language';
import { getSelectedValues } from 'modules/discovery/utils/discovery';

import type { DataStructureCommon, DiscoveryCreatorsAgesFilter, DiscoveryCreatorsShareData } from 'types';

import './discovery-creators-filters-audience-ages.scss';

applyTranslations(require('./discovery-creators-filters-audience-ages.i18n.json'));

type Props = {
  name: string,
  filters: DiscoveryCreatorsAgesFilter,
  onHandleUpdate: (a: Partial<DiscoveryCreatorsAgesFilter>) => void
};

const msgKey = 'discovery_creators_filters_audience_ages';

class DiscoveryCreatorsFiltersAudienceAges extends React.PureComponent<Props> {
  handleAgeToggle = (updatedItems: Array<DataStructureCommon>): void => {
    const { filters, onHandleUpdate } = this.props;
    const agesSelected = getSelectedValues(updatedItems);
    const agesShareCheckbox = filters.share.checkbox || {};

    // deselect the "share" checkbox under certain conditions
    // this keeps the query object builder from including the prop
    // $FlowIgnore – it's okay to have fallback to empty object for agesShareCheckbox
    onHandleUpdate({
      items: updatedItems,
      share: {
        ...filters.share,
        checkbox: {
          ...agesShareCheckbox,
          selected: !isEmpty(agesSelected) && agesShareCheckbox.selected
        }
      }
    });
  };

  handleShareUpdate = (shareData: DiscoveryCreatorsShareData) => {
    const { onHandleUpdate } = this.props;
    onHandleUpdate({
      share: shareData
    });
  };

  renderShare(): React.ReactNode {
    const { name, filters } = this.props;
    const selectedAges = getSelectedValues(filters.items);

    return (
      <DiscoveryCreatorsFiltersShare
        filterName={`audienceAgesShare-${name}`}
        filter={filters.share}
        type="ages"
        isDisabled={isEmpty(selectedAges)}
        onHandleUpdate={this.handleShareUpdate}
      />
    );
  }

  render(): React.ReactNode {
    const { name, filters } = this.props;
    const { items } = filters;

    return (
      <div className="discovery-creators-filters-audience-ages">
        <DiscoveryFiltersTitle
          title={__t(`${msgKey}.labels.age`)}
        />
        <VerticalSpacing type="tiny" />
        <CheckboxSelector
          items={items}
          attribute={`audienceAges-${name}`}
          direction="column"
          customClass="discovery-creators-filters-audience-ages__checkbox-selector"
          containerClass="checkbox-selector__checkbox discovery-creators-filters-audience-ages__checkbox-selector-container"
          onUpdate={this.handleAgeToggle}
        />
        <VerticalSpacing type="medium" />
        {this.renderShare()}
      </div>
    );
  }
}

export default DiscoveryCreatorsFiltersAudienceAges;
